<template>
  <div>
    <CRow class="pt-5">
      <CCol sm="3" v-if="countPages > 1">
        <CPagination :pages="countPages" class="dataTable__pagination" :doubleArrows="false" :active-page.sync="activePage" ref="pagination">
          <template slot="previous-button">
            <span class="pagination__button p-2">
              <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
            </span>
          </template>

          <template slot="next-button">
            <span class="pagination__button p-2">
              <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
            </span>
          </template>
        </CPagination>

        <div class="page-item d-flex justify-content-center paginationDetail text-gray-600">
          <span class="page-active pr-1">{{ activePage }}</span> / {{ countPages }}
        </div>
      </CCol>
      <CCol class="text-right">
        <!-- <button class="btn btn-white px-4 py-3 font-weight-bold text-gray-600" tag="button">
          EXPORT
          <CIcon
            name="arrowExport"
            size="custom-size"
            :height="18"
            class="ml-2"
            viewBox="0 0 32 32"
          />
        </button> -->
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CRow>
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.dateSent') }}
            </div>
            <div class="text-gray-600">
              {{ formatDateTimeFull(activeScheduling.schedulingDatetime) }}
              ({{ activeScheduling.timezone }})
            </div>
          </CCol>
        </CRow>
        <CRow class="mt-3">
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.sender') }}
            </div>
            <div class="text-gray-600">
              {{ activeScheduling.senderName }}
            </div>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.segments') }}
            </div>
            <CRow>
              <CCol sm="7">
                <div v-for="(segment, index) in activeScheduling.segments" :key="index">
                  <CBadge v-if="segment.segmentName" class="font-weight-semi-bold px-3 py-2 font-base mx-1 my-1" color="primary">
                    {{ segment.segmentName }}
                  </CBadge>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol sm="7">
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.performance') }}
            </div>
            <CRow class="mt-2">
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.email.text.uniqueOpen') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('email', activeScheduling.schedulingId, 'uniqueopens')">
                  {{ activeScheduling.performance.uniqueOpenCount }}
                </a>
                <span class="min-w">{{ uniqueOpens }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.email.text.uniqueClicks') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('email', activeScheduling.schedulingId, 'clicks')">
                  {{ activeScheduling.performance.uniqueClickCount }}
                </a>
                <span class="min-w">{{ uniqueClicks }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.email.text.bounced') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('email', activeScheduling.schedulingId, 'bounced')">
                  {{ activeScheduling.performance.bouncedCount }}
                </a>
                <span class="min-w">{{ bounced }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.email.text.markAsSpam') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('email', activeScheduling.schedulingId, 'markedasspam')">
                  {{ activeScheduling.performance.markedAsSpamCount }}
                </a>
                <span class="min-w">{{ spam }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.email.text.unsubscribed') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('email', activeScheduling.schedulingId, 'unsubscribes')">
                  {{ activeScheduling.performance.unsubscribeCount }}
                </a>
                <span class="min-w">{{ unsubscribes }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />
          </CCol>
        </CRow>
      </CCol>

      <!-- Área mensagem -->
      <CCol>
        <figure class="img-crop d-flex align-items-left m-0">
          <img
            v-if="activeScheduling.templateId"
            :src="`${$configs.VUE_APP_ROOT_API}template/email/static/${activeScheduling.templateId}/thumbnail.jpg`"
            alt=""
            width="600"
            height="auto"
            @click.stop="openModal(item)"
          />
        </figure>
      </CCol>
    </CRow>

    <CRow class="mt-4">
      <CCol>
        <apexchart type="line" :options="chartOptions" :series="series" height="400"></apexchart>
      </CCol>
    </CRow>

    <CRow class="mt-4">
      <CCol>
        <CRow>
          <CCol sm="8">
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.topLinksClicked') }}
            </div>
            <div class="scroll-area-message mt-3 pr-none">
              <div v-for="(link, index) in activeScheduling.performance.topLinksClicked" :key="index">
                <CRow>
                  <CCol sm="8" class="text-gray-600">
                    {{ link.link }}
                  </CCol>
                  <CCol class="text-gray-600 text-right">
                    <span class="mr-2">{{ link.count }}</span>
                    <!-- <span class="text-gray-base">{{ '100' }}%</span> -->
                  </CCol>
                </CRow>
                <hr class="mt-1" />
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
      <CCol>
        <CRow>
          <CCol sm="8">
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.email.text.topLocationsBySent') }}
            </div>
            <div class="scroll-area-message mt-3 pr-none">
              <div v-for="(country, index) in activeScheduling.performance.topLocations.open" :key="index">
                <CRow>
                  <CCol sm="2" style="padding-right: 0px; padding-lef: 1px" class="text-left">
                    <img :src="getFlag(country.countryId)" width="30" />
                  </CCol>
                  <CCol sm="5" class="text-gray-600">
                    {{ country.countryId }}
                  </CCol>
                  <CCol class="text-gray-600 text-right">
                    <span class="mr-2 min-w">{{ country.count }}</span>
                    <!-- <span class="text-gray-base">{{ topLocationPercent(activeScheduling, country.count) }}%</span> -->
                  </CCol>
                </CRow>
                <hr class="mt-1" />
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { dateFormatStringFull } from '@/utils/dateUtil.js'
import countries from '../../../../countriesList'
import VueApexCharts from 'vue-apexcharts'
import { DateTime } from 'luxon'

export default {
  props: {
    campaignResult: Object,
  },
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    countPages: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.email.schedulings.length
      }
      return 0
    },
    activeScheduling: function () {
      if (this.campaignResult.channels) {
        this.series = [
          {
            name: 'click',
            data: this.campaignResult.channels.email.schedulings[this.activePage - 1].performance.byPeriod.click.map((elm) => {
              return {
                x: elm.timestamp,
                y: elm.count,
              }
            }),
          },
          {
            name: 'open',
            data: this.campaignResult.channels.email.schedulings[this.activePage - 1].performance.byPeriod.open.map((elm) => {
              return {
                x: elm.timestamp,
                y: elm.count,
              }
            }),
          },
        ]

        return this.campaignResult.channels.email.schedulings[this.activePage - 1]
      }
      return null
    },
  },
  data() {
    return {
      activePage: 1,
      uniqueOpens: 0,
      uniqueClicks: 0,
      bounced: 0,
      unsubscribes: 0,
      spam: 0,
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        colors: ['#ff5924', '#17d26f'],
        stroke: {
          curve: 'straight',
        },
        markers: {
          size: 5,
          shape: 'circle',
          hover: {
            size: 7,
          },
        },
        title: {
          text: '1 Week',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: false,
            formatter: function (value) {
              const dateTime = DateTime.fromMillis(value)

              return dateTime.toFormat('dd/MM/yyyy HH:mm')
            },
          },
          offsetX: 30,
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter: function (val) {
              return val.toFixed(0)
            },
          },
        },
      },
    }
  },
  methods: {
    formatDateTimeFull(date) {
      return dateFormatStringFull(date)
    },
    getFlag(key) {
      return countries.find((elm) => elm.code === key)?.flag
    },

    redirctToResume(scheduleType, scheduleId, type) {
      this.$router.push({
        name: 'campaignResume',
        params: {
          campaignId: this.$route.params.campaignId,
          scheduleType: scheduleType,
          scheduleId: scheduleId,
          type: type,
        },
      })
    },
    calculatingPercent() {
      if (this.activeScheduling && this.activeScheduling.performance && this.activeScheduling.totalRecipientsCount > 0) {
        let totalRecipientsCount = isNaN(this.activeScheduling.totalRecipientsCount) ? 0 : this.activeScheduling.totalRecipientsCount
        let uniqueClickCount = isNaN(this.activeScheduling.performance.uniqueClickCount) ? 0 : this.activeScheduling.performance.uniqueClickCount
        let uniqueOpen = isNaN(this.activeScheduling.performance.uniqueOpenCount) ? 0 : this.activeScheduling.performance.uniqueOpenCount
        let bouncedCount = isNaN(this.activeScheduling.performance.bouncedCount) ? 0 : this.activeScheduling.performance.bouncedCount
        let unsubscribeCount = isNaN(this.activeScheduling.performance.unsubscribeCount) ? 0 : this.activeScheduling.performance.unsubscribeCount
        let spamCount = isNaN(this.activeScheduling.performance.markedAsSpamCount) ? 0 : this.activeScheduling.performance.markedAsSpamCount

        this.uniqueOpens = totalRecipientsCount > 0 ? Math.round((uniqueOpen * 100) / totalRecipientsCount) : 0
        this.uniqueClicks = uniqueOpen > 0 ? Math.round((uniqueClickCount * 100) / uniqueOpen) : 0
        this.bounced = totalRecipientsCount > 0 ? Math.round((bouncedCount * 100) / totalRecipientsCount) : 0
        this.unsubscribes = totalRecipientsCount > 0 ? Math.round((unsubscribeCount * 100) / totalRecipientsCount) : 0
        this.spam = totalRecipientsCount > 0 ? Math.round((spamCount * 100) / totalRecipientsCount) : 0

        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    topLocationPercent(item, value) {
      let result = 0
      if (item && item.performance && item.performance.openCount > 0) {
        result = Math.round((value * 100) / item.performance.openCount)
      }
      // if (item && item.performance && item.totalRecipientsCount > 0) {
      //   result = Math.round((value * 100) / item.totalRecipientsCount)
      // }
      return result
    },

    topLinksPercent(item, value) {
      let result = 0
      if (item && item.performance && item.performance.clickCount > 0) {
        result = Math.round((value * 100) / item.performance.clickCount)
      }
      // if (item && item.performance && item.totalRecipientsCount > 0) {
      //   result = Math.round((value * 100) / item.totalRecipientsCount)
      // }
      return result > 100 ? 100 : result
    },
  },
  watch: {
    activeScheduling: function (newSchedule) {
      if (newSchedule) {
        this.calculatingPercent()
      }
    },
  },
  mounted() {
    this.calculatingPercent()
  },
}
</script>

<style lang="scss">
.performance-link {
  cursor: pointer;
  text-decoration: underline !important;
}

.performance-desc {
  font-size: $font-size-xs !important;
  font-weight: $font-weight-semi-bold;
}

.scroll-area-message {
  overflow-y: auto;
  overflow-x: hidden;
  height: 250px;
}
</style>
